import {Directive} from '@angular/core';
import {BaseComponent} from '../../abstract/base.component';

@Directive()
// tslint:disable-next-line:directive-class-suffix
export abstract class SendChangeRequestAction extends BaseComponent {
  protected _sendChangeRequestUrl: string;
  protected abstract passChangeRequestResponse(res);
  protected abstract passChangeRequestError(err);
  protected SendChangeRequest(postBody) {
    this.loadFlag = true;
    this.dataManager.postRequest(this._sendChangeRequestUrl, postBody, 0)
      .subscribe(
        (response) => {
          this.loadFlag = false;
          this.passChangeRequestResponse(response);
        },
        error => {
          this.loadFlag = false;
          this.networkErrorHandler(error);
          this.passChangeRequestError(error.error);
        }
      );
  }
}
